import classNames from 'classnames';
import React, { useRef } from 'react';
import IconFont from '@meitu/xdesign-icon-font';
import { useFramework } from '@/framework';
import { ContextMenuPlugin } from '../context-menu';
import { DEFAULT_SPACE, IMenuItemProps } from '../type';

const MenuItem: React.FC<IMenuItemProps> = React.memo(
    ({ childMenus, disabled, icon, name, desc, onClick, onMouseEnter, onMouseLeave, active, style = {} }) => {
        console.log('MenuItem', active);
        const framework = useFramework();
        const contextMenu = framework.getInstance(ContextMenuPlugin);
        const childMenuRef = useRef<HTMLDivElement>(null);
        const onMouseEnterHandler = (e: React.MouseEvent) => {
            e.stopPropagation();
            onMouseEnter?.(e);
            if (childMenus?.length && childMenuRef.current) {
                const { bottom: childMenuBottom } = childMenuRef.current.getBoundingClientRect();
                if (childMenuBottom > contextMenu.positionInfo.bottom - DEFAULT_SPACE) {
                    childMenuRef.current.classList.add('bottom');
                }
                childMenuRef.current.classList.remove('left', 'right');
                const dir = contextMenu.positionInfo.arrowMenuInRight ? 'right' : 'left';
                childMenuRef.current.classList.add(dir);
            }
        };
        const onMouseLeaveHandler = (e: React.MouseEvent) => {
            e.stopPropagation();
            onMouseLeave?.(e);
        };
        const onClickHandler = (e: React.MouseEvent) => {
            e.stopPropagation();
            if (childMenus?.length || disabled) return;
            onClick?.(e);
            contextMenu.close();
        };

        return (
            <div
                className={classNames('l-content-menu__item', { disabled, active })}
                onClick={onClickHandler}
                onMouseEnter={onMouseEnterHandler}
                onMouseLeave={onMouseLeaveHandler}
                style={{ ...style }}
            >
                {childMenus?.length ? (
                    <div className={classNames('l-content-menu', 'l-content-menu-children')} ref={childMenuRef}>
                        {childMenus?.map((item) => {
                            return <MenuItem key={item.type} {...item}></MenuItem>;
                        })}
                    </div>
                ) : null}
                <div className="l-content-menu__item__title">
                    {!icon ? null : typeof icon === 'string' ? (
                        <div className="l-layer__icon">
                            <IconFont name={icon} fontSize={16} />
                        </div>
                    ) : (
                        icon
                    )}
                    <span>{name}</span>
                </div>
                {childMenus?.length ? (
                    <span>
                        <IconFont name="ChevronRightBold" fontSize={14} />
                    </span>
                ) : (
                    <>{desc && <span>{desc}</span>}</>
                )}
            </div>
        );
    },
);

export default MenuItem;
